import api from './index';
//
let exports = {};
// ========================== 人员入职 ==========================
exports.getStaffEnrollFormById = function (data, callback) { // 人员入职单详情
    api.get('/staff/biz/staff/enroll/from/get')
        .params(data)
        .done(callback)
        .go();
};

exports.getStaffEnrollFormPageList = function (data, callback) { // 人员入职单列表
    api.post('/staff/biz/staff/enroll/from/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.updateStaffEnrollFormForAudit = function (data, callback) { // 人员入职-审核
    api.post('/staff/biz/staff/enroll/from/update/for/audit/do')
    .data(data)
    .done(callback)
    .go();
};

// ========================== 人员离职 ==========================

exports.getStaffResignFormPageList = function (data, callback) { // 人员离职单列表
    api.post('/staff/biz/staff/resign/from/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveStaffResignForm = function (data, callback) { // 人员离职单-新增
    api.post('/staff/biz/staff/resign/from/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateStaffResignFormForAudit = function (data, callback) { // 人员离职-审核
    api.post('/staff/biz/staff/resign/from/update/for/audit/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateStaffResignFormHandoverState = function (data, callback) {// 存在交接的离职单 - 开始交接
    api.post('/staff/biz/staff/resign/form/handoverState/update/do')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/staffBiz.js
// module id = 155
// module chunks = 1